import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';

import { ProcessesPage } from './processes.page';
import { PipesModule } from '../shared/pipes/pipes.module';
import { ProcessesService } from './processes.service';
import { VersionPreviewComponent } from './version-preview/version-preview.component';
import { AttributesService } from './attributes.service';

const routes: Routes = [{
  path: '',
  component: ProcessesPage
}];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    PipesModule,
  ],
  declarations: [
    ProcessesPage,
    VersionPreviewComponent,
  ],
  providers: [
    ProcessesService,
    AttributesService
  ],
})
export class ProcessesPageModule { }
